import { Fragment } from 'react'
import { Link } from 'react-router-dom'

import ChevronRight from '@Icons/chevron-right.svg?react'
import HomeButton from '@Icons/home-button-icon.svg?react'

interface MainHeaderProps {
  title: React.ReactNode
  subtitle?: React.ReactNode
  extra?: React.ReactNode
  rightTitle?: React.ReactNode
  isLoading?: boolean
  className?: string
  breadcrumb?: { title: React.ReactNode; link?: string }[]
}

function MainHeader({
  title,
  subtitle,
  extra,
  rightTitle,
  isLoading,
  className,
  breadcrumb,
}: MainHeaderProps): JSX.Element {
  const initialCrumbs = breadcrumb?.slice(0, -1) ?? []
  const lastCrumb = breadcrumb?.slice(-1)?.[0] ?? null

  return (
    <>
      {initialCrumbs?.length ? (
        <div className="flex flex-row items-center mb-4" key={-1}>
          <Link to="/">
            <button className="pr-4 flex flex-row items-center">
              <HomeButton />
            </button>
          </Link>
          <div>
            <ChevronRight />
          </div>
          {initialCrumbs.map((item, index) => (
            <Fragment key={index}>
              {item.link ? (
                <Link to={item.link}>
                  <button>
                    <span className="px-4 font-medium text-sm text-gray-500">
                      {item.title}
                    </span>
                  </button>
                </Link>
              ) : (
                <button>
                  <span className="px-4 font-medium text-sm text-gray-500">
                    {item.title}
                  </span>
                </button>
              )}
            </Fragment>
          ))}
          <ChevronRight />
          <button key={initialCrumbs.length}>
            <span className="pl-4 font-medium text-sm text-primary-700">
              {lastCrumb?.title}
            </span>
          </button>
        </div>
      ) : (
        <></>
      )}
      <div
        className={
          'flex flex-col justify-between items-start box-content md:flex-row border-b-2 pb-2 border-solid border-gray-200' +
          (className ? ` ${className}` : '')
        }
      >
        {isLoading ? (
          <>
            <div className="flex flex-col flex-1">
              <div className="animate-pulse bg-gray-200 h-5 w-3/5 rounded-md"></div>
              <div className="animate-pulse bg-gray-200 h-3 w-2/5 rounded-md mt-2"></div>
            </div>
            <div className="flex items-start w-5/12">
              <div className="flex flex-col md:flex-row w-full">
                <div className="flex flex-row flex-1 space-x-3 md:mr-3">
                  <div className="animate-pulse w-1/3 h-8 rounded-lg bg-gray-200"></div>
                  <div className="animate-pulse w-1/3 h-8 rounded-lg bg-gray-200"></div>
                  <div className="animate-pulse w-1/3 h-8 rounded-lg bg-gray-200"></div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="flex flex-col flex-1">
              <h1 className="text-medium text-[1.875rem] leading-[1.875rem] text-gray-900 mb-1">
                {title}
              </h1>
              {subtitle ? subtitle : <></>}
            </div>
            {rightTitle ? (
              <div className="flex flex-col justify-end h-[1.875rem]">
                <p className="font-normal text-base  text-gray-500">
                  {rightTitle}
                </p>
              </div>
            ) : extra ? (
              <div className="flex flex-col md:flex-row flex-1 justify-end h-full mb-1">
                {extra}
              </div>
            ) : (
              <></>
            )}
          </>
        )}
      </div>
    </>
  )
}

export default MainHeader
